import { feathers } from "@feathersjs/feathers";
import authenticationClient from "@feathersjs/authentication-client";
//#region src/services/child/child.shared.ts
var childMethods = ["find", "get"];
var childPath = "child";
var childClient = (client) => {
	const connection = client.get("connection");
	client.use(childPath, connection.service(childPath), { methods: childMethods });
};
//#endregion
//#region src/services/leave-request/leave-request.shared.ts
var leaveRequestMethods = [
	"find",
	"get",
	"create",
	"patch",
	"remove"
];
var leaveRequestPath = "leave-request";
var leaveRequestClient = (client) => {
	const connection = client.get("connection");
	client.use(leaveRequestPath, connection.service(leaveRequestPath), { methods: leaveRequestMethods });
};
//#endregion
//#region src/services/leave-request-attachment/leave-request-attachment.shared.ts
var leaveRequestAttachmentMethods = [
	"find",
	"get",
	"create",
	"remove",
	"notifyAdded"
];
var leaveRequestAttachmentPath = "leave-request-attachment";
var leaveRequestAttachmentClient = (client) => {
	const connection = client.get("connection");
	client.use(leaveRequestAttachmentPath, connection.service(leaveRequestAttachmentPath), { methods: leaveRequestAttachmentMethods });
};
//#endregion
//#region src/services/medical-request/medical-request.shared.ts
var medicalRequestMethods = [
	"find",
	"get",
	"create",
	"patch",
	"remove"
];
var medicalRequestPath = "medical-request";
var medicalRequestClient = (client) => {
	const connection = client.get("connection");
	client.use(medicalRequestPath, connection.service(medicalRequestPath), { methods: medicalRequestMethods });
};
//#endregion
//#region src/services/parent-session/parent-session.shared.ts
var parentSessionMethods = ["find", "remove"];
var parentSessionPath = "parent-session";
/** Registers the parent-session client service on a Feathers client application. */
var parentSessionClient = (client) => {
	const connection = client.get("connection");
	client.use(parentSessionPath, connection.service(parentSessionPath), { methods: parentSessionMethods });
};
//#endregion
//#region src/services/push-device/push-device.shared.ts
var pushDeviceMethods = [
	"find",
	"get",
	"create",
	"patch",
	"remove",
	"sendTest"
];
var pushDevicePath = "push-device";
/** Registers the push-device client service on a Feathers client application. */
var pushDeviceClient = (client) => {
	const connection = client.get("connection");
	client.use(pushDevicePath, connection.service(pushDevicePath), { methods: pushDeviceMethods });
};
//#endregion
//#region src/services/pickup-request/pickup-request.shared.ts
var pickupRequestMethods = [
	"find",
	"create",
	"remove"
];
var pickupRequestPath = "pickup-request";
var pickupRequestClient = (client) => {
	const connection = client.get("connection");
	client.use(pickupRequestPath, connection.service(pickupRequestPath), { methods: pickupRequestMethods });
};
//#endregion
//#region src/services/profile/profile.shared.ts
var profileMethods = [
	"find",
	"get",
	"patch"
];
var profilePath = "profile";
/** Registers the profile client service on a Feathers client application. */
var profileClient = (client) => {
	const connection = client.get("connection");
	client.use(profilePath, connection.service(profilePath), { methods: profileMethods });
};
//#endregion
//#region src/services/profile-history/profile-history.shared.ts
var profileHistoryMethods = ["find"];
var profileHistoryPath = "profile-history";
/** Registers the profile-history client service on a Feathers client application. */
var profileHistoryClient = (client) => {
	const connection = client.get("connection");
	client.use(profileHistoryPath, connection.service(profileHistoryPath), { methods: profileHistoryMethods });
};
//#endregion
//#region src/services/school-year/school-year.shared.ts
var schoolYearMethods = ["get"];
var schoolYearPath = "school-year";
var schoolYearClient = (client) => {
	const connection = client.get("connection");
	client.use(schoolYearPath, connection.service(schoolYearPath), { methods: schoolYearMethods });
};
//#endregion
//#region src/client.ts
/**
* Returns a typed client for the s4p-server app.
*
* @param connection The REST or Socket.io Feathers client connection
* @param authenticationOptions Additional settings for the authentication client
* @see https://dove.feathersjs.com/api/client.html
* @returns The Feathers client application
*/
var createClient = (connection, authenticationOptions = {}) => {
	const client = feathers();
	client.configure(connection);
	client.configure(authenticationClient(authenticationOptions));
	client.set("connection", connection);
	client.configure(childClient);
	client.configure(leaveRequestClient);
	client.configure(leaveRequestAttachmentClient);
	client.configure(medicalRequestClient);
	client.configure(parentSessionClient);
	client.configure(pushDeviceClient);
	client.configure(pickupRequestClient);
	client.configure(profileClient);
	client.configure(profileHistoryClient);
	client.configure(schoolYearClient);
	return client;
};
//#endregion
export { createClient };

//# sourceMappingURL=client.mjs.map